export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M12 2.031a.75.75 0 0 1 .75.75V19.44l1.549-1.548a.75.75 0 1 1 1.06 1.06l-2.83 2.828-.056.052a.75.75 0 0 1-1.004-.052l-2.828-2.828a.75.75 0 0 1 1.06-1.06l1.549 1.547V2.781a.75.75 0 0 1 .75-.75Z"/>
</svg>
`;
